// Keep legacy RequireName sessions working until their administrator explicitly
// chooses one of the new modes. Anonymous is public display policy, not a claim
// that an organizer cannot associate a privately supplied participant profile.
export function questionIdentityMode(settings = {}) {
  const mode = String(settings.questionIdentityMode || '').toLowerCase()
  if (mode === 'anonymous') return 'Anonymous'
  if (mode === 'required') return 'Required'
  return 'Optional'
}

export function participantNameRequired(settings = {}) {
  const mode = questionIdentityMode(settings)
  return mode === 'Required' || (mode === 'Optional' && settings.requireName === true)
}

export function publicQuestionAuthor(question, settings, anonymousLabel) {
  return questionIdentityMode(settings) === 'Anonymous' || !question?.author || question.author === 'Anonymous'
    ? anonymousLabel : question.author
}
